import { getRequest } from '../../utils/apiUtils';


export const STATUS_VIEW_DATA = 'STATUS_VIEW_DATA'

export function getStatusViewData(parameters) {
    return (dispatch) => {
        return dispatch(getStatusViewDataAction(parameters))
    }
}

function getStatusViewDataAction({ year, fId }) {
    return async (dispatch) => {
        return await getRequest({ url: `api/managed_matrix_allocation?year=${year}&contract_facility_id=${fId}` })
        .then((response) => {
            if(response.data.result.length>0)
          {
            dispatch(statusViewDataReducer(response.data.result))
          }
          else
          {
            dispatch(statusViewDataReducer([]))
          }
        })
    }
}

function statusViewDataReducer(response) {
    return {
        type: STATUS_VIEW_DATA,
        status_view_data: response
      }
}


// WEBPACK FOOTER //
// ./src/shared/actions/statusView_action.js